"use client";

import { useEmployeeInfo } from "@/modules/hooks/employee/useEmployeeInfo";
import { EmployeeInfo } from "@/modules/types/employee/employee";
import { useEffect } from "react";

export default function CheckAuthProvider({
  strictCheck = false,
  employeeInfoServerProps,
  children,
}: {
  strictCheck?: boolean;
  employeeInfoServerProps?: EmployeeInfo;
  children?: React.ReactNode;
}) {
  const { employeeInfo, getEmployeeInfo, setEmployeeInfo } =
    useEmployeeInfo(strictCheck);

  useEffect(() => {
    if (employeeInfoServerProps) {
      setEmployeeInfo(employeeInfoServerProps);
    } else if (!employeeInfo) {
      getEmployeeInfo();
    }
  }, []);

  return <>{children}</>;
}
